var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.681641,
    width: 36,
    height: 16.6364,
    rx: 8,
    fill: "#DEF3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6528 3.09069C10.5324 2.84071 10.2779 2.68164 9.99837 2.68164C9.71885 2.68164 9.46661 2.84071 9.34389 3.09069L7.88269 6.09718L4.6194 6.57895C4.3467 6.61985 4.11945 6.81074 4.03537 7.07208C3.95129 7.33342 4.01946 7.62202 4.2149 7.81518L6.58282 10.1581L6.02379 13.4691C5.97834 13.7418 6.09197 14.0191 6.31694 14.1804C6.54192 14.3418 6.83961 14.3622 7.08504 14.2327L10.0006 12.676L12.9162 14.2327C13.1617 14.3622 13.4594 14.344 13.6843 14.1804C13.9093 14.0168 14.0229 13.7418 13.9775 13.4691L13.4162 10.1581L15.7841 7.81518C15.9795 7.62202 16.05 7.33342 15.9636 7.07208C15.8773 6.81074 15.6523 6.61985 15.3796 6.57895L12.114 6.09718L10.6528 3.09069Z",
    fill: "#38C16F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6528 3.09069C26.5324 2.84071 26.2779 2.68164 25.9984 2.68164C25.7189 2.68164 25.4666 2.84071 25.3439 3.09069L23.8827 6.09718L20.6194 6.57895C20.3467 6.61985 20.1195 6.81074 20.0354 7.07208C19.9513 7.33342 20.0195 7.62202 20.2149 7.81518L22.5828 10.1581L22.0238 13.4691C21.9783 13.7418 22.092 14.0191 22.3169 14.1804C22.5419 14.3418 22.8396 14.3622 23.085 14.2327L26.0006 12.676L28.9162 14.2327C29.1617 14.3622 29.4594 14.344 29.6843 14.1804C29.9093 14.0168 30.0229 13.7418 29.9775 13.4691L29.4162 10.1581L31.7841 7.81518C31.9795 7.62202 32.05 7.33342 31.9636 7.07208C31.8773 6.81074 31.6523 6.61985 31.3796 6.57895L28.114 6.09718L26.6528 3.09069Z",
    fill: "#38C16F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoStar);
export default __webpack_public_path__ + "static/media/two_star.387797e4ab346010c6a588c55961a050.svg";
export { ForwardRef as ReactComponent };